"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SalableItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Translations = require("react-platform-components/dist/Translations");
var _useDebounceValue3 = require("react-platform-components/dist/hooks/useDebounceValue");
var _helpers = require("react-platform-components/dist/helpers");
var _config = require("../../config");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    // salable item
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    salableItemImage: _defineProperty({
      width: '80%',
      aspectRatio: 1,
      objectFit: 'contain'
    }, theme.breakpoints.up('sm'), {
      height: 120,
      width: '100%'
    }),
    salableItemContainer: {
      border: '1px dashed #bdbdbd',
      borderRadius: 20,
      marginTop: 25,
      padding: '1rem',
      '&:hover': {
        boxShadow: '0px 0px 10px #bdbdbd',
        transition: 'box-shadow 0.3s ease-in-out'
      }
    },
    salableItemDescriptionArea: {
      padding: '1rem'
    },
    salableItemActionButtons: {
      justifyContent: 'space-between'
    },
    itemName: {
      marginLeft: 12
    },
    quantityButtonGroup: {
      marginRight: '1rem'
    },
    totalPrice: _defineProperty({
      marginLeft: 12
    }, theme.breakpoints.down('sm'), {
      marginTop: 8,
      marginRight: 8
    })
  };
});
var SalableItem = function SalableItem(props) {
  var classes = useStyles();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.shoppingCartReducer;
    }),
    updateItemInProgress = _useSelector.updateItemInProgress,
    fetchCartItemsInProgress = _useSelector.fetchCartItemsInProgress,
    deleteItemInProgress = _useSelector.deleteItemInProgress;
  var cartItem = props.cartItem,
    onUpdateQuantity = props.onUpdateQuantity,
    onDelete = props.onDelete;
  var salable_item = cartItem.salable_item,
    can_update_quantity = cartItem.can_update_quantity,
    total_price = cartItem.total_price;
  var _useDebounceValue = (0, _useDebounceValue3.useDebounceValue)(cartItem === null || cartItem === void 0 ? void 0 : cartItem.quantity, function (val) {
      return onUpdateQuantity(val);
    }, 900),
    _useDebounceValue2 = _slicedToArray(_useDebounceValue, 2),
    quantity = _useDebounceValue2[0],
    setQuantity = _useDebounceValue2[1];
  var imageUrl = !_lodash.default.isEmpty(salable_item === null || salable_item === void 0 ? void 0 : salable_item.main_image) ? (0, _helpers.joinPaths)(_config.BASE_URL, salable_item.main_image.name["500x500"]) : !_lodash.default.isEmpty(salable_item === null || salable_item === void 0 ? void 0 : salable_item.images) ? (0, _helpers.joinPaths)(_config.BASE_URL, salable_item.images[0].name['500x500']) : _config.DEFAULT_IMAGE_FOR_SHOPPING_CART_ITEM_URL;
  var isDisabled = updateItemInProgress || fetchCartItemsInProgress || deleteItemInProgress;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    className: classes.salableItemContainer,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    xs: 12,
    md: 2,
    className: classes.imageContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.salableItemImage,
    src: imageUrl,
    alt: salable_item.salable_item_mxn_name
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    xs: 12,
    md: 10,
    className: classes.salableItemDescriptionArea
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    md: 12,
    className: classes.salableItemActionButtons
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1",
    className: classes.itemName
  }, " ", salable_item.salable_item_mxn_name, " ")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    alignItems: "center",
    className: classes.salableItemDescriptionAreaActions
  }, can_update_quantity && /*#__PURE__*/_react.default.createElement(_core.ButtonGroup, {
    className: classes.quantityButtonGroup,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: isDisabled || quantity <= 1,
    "aria-label": "reduce",
    onClick: function onClick() {
      return setQuantity(quantity - 1);
    }
  }, /*#__PURE__*/_react.default.createElement(_Remove.default, {
    fontSize: "small"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: true,
    "aria-label": "Quantity"
  }, quantity), /*#__PURE__*/_react.default.createElement(_core.Button, {
    "aria-label": "increase",
    disabled: isDisabled || quantity >= salable_item.quantity,
    onClick: function onClick() {
      return setQuantity(quantity + 1);
    }
  }, /*#__PURE__*/_react.default.createElement(_Add.default, {
    fontSize: "small"
  }))), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.removeButton,
    variant: _config.USE_OUTLINED_BUTTON ? 'contained' : 'outlined',
    color: _config.USE_PRIMARY_COLOR ? 'primary' : 'secondary',
    "aria-label": "delete",
    disabled: isDisabled,
    onClick: onDelete,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Retirer",
    defaultMessage: "Retirer"
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    md: 12,
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: classes.totalPrice
  }, _config.PROPOSITIONS_USED_IN_CHAT && salable_item.original_price !== salable_item.price && /*#__PURE__*/_react.default.createElement("del", null, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: salable_item.original_price * salable_item.quantity,
    style: "currency",
    currency: "EUR"
  })), "\xA0", /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: total_price,
    style: "currency",
    currency: "EUR"
  }))))));
};
exports.SalableItem = SalableItem;